<template>
  <div>
    <v-app-bar flat app>
      <v-app-bar-nav-icon
        v-if="isLoggedIn"
        class="grey--text"
        @click="navDrawerToggle"
      />
      <v-toolbar-title class="grey--text">
        <span class="font-weight-light text-h5">PoolCare</span>
        <span class="font-weight-bold text-uppercase">Pro</span>
      </v-toolbar-title>
      <v-spacer />
      <div class="d-flex">
        <SubscribeButton />
        <SearchButton />
        <LoginButton />
      </div>
    </v-app-bar>

    <NavDrawer :state="navDrawerState" />
    <ReportHandler />
  </div>
</template>

<script>
import { ref } from 'vue'
import { isLoggedIn } from '@/store/UserSession'
import NavDrawer from '@/components/layout/NavDrawer'
import SearchButton from '@/components/layout/SearchButton'
import SubscribeButton from '@/components/layout/SubscribeButton'
import LoginButton from '@/components/layout/LoginButton'
import ReportHandler from '@/components/layout/ReportHandler'

export default {
  name: 'NavBar',
  components: {
    LoginButton,
    NavDrawer,
    ReportHandler,
    SearchButton,
    SubscribeButton
  },
  setup() {
    const navDrawerState = ref(1)

    const navDrawerToggle = () => {
      navDrawerState.value++
    }

    return {
      isLoggedIn,
      navDrawerState,
      navDrawerToggle
    }
  }
}
</script>
